export const TYPE_LABELS = {
  single: 'Single',
  account: 'Account',
  profile: 'Profile',
  accountSel: 'Account',
  profileSel: 'Profile',
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString(undefined, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
};
